export {};
//# sourceMappingURL=IPhysicsEngine.js.map